module.exports = __webpack_public_path__ + "img/code.c6b6891c.png";